import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect } from 'react-redux';

import { withRouter, WithRouterProps } from 'react-router';
import { loginUser } from '@bart.sk-eshop/react-auth/lib/containers/Auth/actions';
import { UrlHashService } from '../../services/HashService';
import InfoBanner from '../../components/_helpers/Default/InfoBanner';
import { push, replace } from 'react-router-redux';
import { onlyPublic } from '../../utilities/auth';
import {
  setBreadCrumbPath,
  BreadCrumbType,
} from '../BreadCrumb/breadCrumbSlice';
import { cartIdSelector } from '../Cart/cartSlice';
import { langSelector } from '../Category/selectors';
import {
  resolveBaseApiUrlByLang,
  resolveBaseUrlByLang,
} from '../../configureTrans';
import { __, __r } from '@bart.sk-eshop/react-i18n';
import LoginFormWrapper from '../../components/_helpers/forms/LoginFormWrapper';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';

interface Props {
  cartId: string | undefined;
  dispatch: (action: any) => void;
  lang: string;
}

interface State {
  error: string;
}

const Wrapper = styled.div`
  width: 100%;
  max-width: auto;
  margin: ${rem(80)} auto;

  ${({ theme }) => theme.mediab.l925`
     padding: 0 ${rem(16)};
     margin: ${rem(32)} auto;
  `}
`;

class LoginPage extends React.Component<Props & WithRouterProps, State> {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
    };
  }

  public componentDidMount() {
    this.props.dispatch(setBreadCrumbPath(BreadCrumbType.LOGIN, null));

    const { hash } = this.props.location;

    const urlHashService = new UrlHashService(hash.replace('#', ''));
    const accessToken = urlHashService.get('access_token');
    const error = decodeURIComponent(urlHashService.get('error'));
    const previousUrl = decodeURIComponent(urlHashService.get('state'));

    const backtocart = hash.search('backtocart');

    if (accessToken) {
      this.props.dispatch(loginUser(accessToken));
      if (backtocart > 0) {
        this.props.dispatch(
          replace(__r('routes:kosik/pokladna', '/kosik/pokladna')),
        );
      }

      // window.location.href = previousUrl;
      // this.props.dispatch(push('/'));
    } else if (error) {
      this.setState({
        error: error && error !== 'null' ? error : '',
      });
    }
  }

  public render() {
    const {
      cartId,
      location: { pathname, search },
      lang,
    } = this.props;
    const { error } = this.state;

    return (
      <>
        <Wrapper>
          <MetaTags tags={{ title: __('Prihlásenie') }} />
          <LoginFormWrapper
            baseApiUrl={resolveBaseApiUrlByLang(lang)}
            baseUrl={resolveBaseUrlByLang(lang)}
            cartId={cartId}
            pathname={pathname}
            search={search}
            error={error}
            lang={lang}
            onFacebookLogin={this.handleFacebookLogin}
            onGoogleLogin={this.handleGoogleLogin}
          />
        </Wrapper>
      </>
    );
  }

  public handleFacebookLogin = () => {
    const { lang } = this.props;
    const redirectUri = encodeURIComponent(
      `${window.location.origin}${__r('routes:prihlasenie', '/prihlasenie')}`,
    );
    window.location.href = `${process.env.REACT_APP_API_BASE_URL}/oauth/facebook?state="${this.props.cartId}"&lang=${lang}&redirect_uri=${redirectUri}`;
  };

  public handleGoogleLogin = () => {
    const { lang } = this.props;
    const redirectUri = encodeURIComponent(
      `${window.location.origin}${__r('routes:prihlasenie', '/prihlasenie')}`,
    );
    window.location.href = `${process.env.REACT_APP_API_BASE_URL}/oauth/google?state="${this.props.cartId}"&lang=${lang}&redirect_uri=${redirectUri}`;
  };
}

const mapStateToProps = state => {
  return {
    cartId: cartIdSelector(state),
    lang: langSelector(state),
  };
};

const withRouterLoginPage = onlyPublic(LoginPage);
export default connect(mapStateToProps)(withRouter(withRouterLoginPage));
